/* eslint-disable unicorn/no-this-assignment */
/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';
import Select from '../../../components/Select';

const CLICK_EVENT = 'click';

class OfficialDirectory {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.od-homepage');
		if (!this._wrapper) {
			return;
		}
		this.initEvents();
		this.state = {
			nameInput: '',
			officialNumberInput: '',
			selectedRoles: [],
			selectedCounty: []
		};
	}

	initEvents() {
		const current = this;
		const name = SelectorEngine.findOne('.lta-official-directory-name-input', this._wrapper);
		const offcialNumber = SelectorEngine.findOne('.lta-official-directory-official-number-input', this._wrapper);
		const role = SelectorEngine.findOne('.lta-official-directory-role-select', this._wrapper);
		const county = SelectorEngine.findOne('.lta-official-directory-county-select', this._wrapper);
		const searchButton = SelectorEngine.findOne('.official-directory-serach-btn', this._wrapper);
		const formElement = SelectorEngine.findOne('.js-official-directory-search-form', this._wrapper);
		if (name) {
			EventHandler.on(name, 'change', (event) => {
				this.saveNameInput(event);
			});
		}

		if (offcialNumber) {
			EventHandler.on(offcialNumber, 'change', (event) => {
				this.saveOfficialNumberInput(event);
			});
		}

		if (role) {
			this.roleElement = SelectorEngine.findOne('.js-lta-select', role);
			this.roleSelect = Select.getInstance(this.roleElement) || new Select(this.roleElement);
			EventHandler.on(this.roleSelect._selectNativeElement, 'change', (event) => {
				this.saveRoles(event);
			});
		}

		if (county) {
			this.countyElement = SelectorEngine.findOne('.js-lta-select', county);
			this.countySelect = Select.getInstance(this.countyElement) || new Select(this.countyElement);
			EventHandler.on(this.countySelect._selectNativeElement, 'change', (event) => {
				this.saveCounty(event);
			});
		}

		EventHandler.on(searchButton, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});
	}

	saveNameInput(event) {
		const targetValue = event.target.value;
		this.state.nameInput = targetValue;
	}

	saveOfficialNumberInput(event) {
		const targetValue = event.target.value;
		this.state.officialNumberInput = targetValue;
	}

	saveRoles(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedRoles = selectedValues;
	}

	saveCounty(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedCounty = selectedValues;
	}

	generateQueryString(formElement) {
		formElement.submit();
	}

	encodeParam(value) {
		return encodeURIComponent(value.replace(/&/g, '&amp;'));
	}
}

const globalOfficialDirectory = new OfficialDirectory();
export default globalOfficialDirectory;
